import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import * as React from "react";
import {StyledButton} from "../Common/StyledButton";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

interface LanguageSelectionMenuProps {
    availableLocales: string[],
    locale: string,
    setLocale: (locale: string) => void,
}

const LanguageSelectionMenu = ({availableLocales, locale, setLocale} : LanguageSelectionMenuProps) => {

    const [anchorElLanguage, setAnchorElLanguage] = React.useState<null | HTMLElement>(null);

    const handleCloseLanguageMenu = () => {
        setAnchorElLanguage(null);
    };

    const handleSelectLanguage = (event: React.MouseEvent<HTMLElement>) => {
        setLocale(event.currentTarget.dataset.value!);
        handleCloseLanguageMenu();
    };

    const isLanguageMenuOpen = anchorElLanguage !== null;

    const handleOpenLanguageMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElLanguage(event.currentTarget);
    };
    
    return <Box sx={{flexGrow: 0, ml: "auto"}}>
        <Tooltip title="Select Language">
            <StyledButton
                id="lang-select-button"
                disableRipple
                aria-controls={isLanguageMenuOpen ? "fade-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={isLanguageMenuOpen ? "true" : undefined}
                onClick={handleOpenLanguageMenu}
                variant="contained"
                endIcon={isLanguageMenuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            >
                { locale }
            </StyledButton>
        </Tooltip>
        <Menu
            sx={{mt: "45px"}}
            id="menu-appbar"
            anchorEl={anchorElLanguage}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(anchorElLanguage)}
            onClose={handleCloseLanguageMenu}
        >
            {availableLocales.map((setting) => (
                <MenuItem key={setting} data-value={setting} onClick={handleSelectLanguage}>
                    <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
            ))}
        </Menu>
    </Box>
};

export default LanguageSelectionMenu;